document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.accordion-item-container');
    const accordionImages = document.querySelectorAll('.ps-image-section .accordion-image');

    function setActiveItem(index) {
        accordionItems.forEach(item => {
            item.classList.remove('active')
            const accordionItem = item.querySelector('.accordion-item');
            accordionItem.classList.remove('active');
            const accordionClose = accordionItem.querySelector('.accordion-close');
            accordionClose.innerHTML = "Open";

            const content = accordionItem.querySelector(".accordion-content");
            content.style.height = 0;
        });
            
        accordionItems[index].classList.add('active');
        const accordionItem = accordionItems[index].querySelector('.accordion-item');
        accordionItem.classList.add('active')
        const accordionClose = accordionItem.querySelector('.accordion-close');
        accordionClose.innerHTML = "Close";

        const content = accordionItem.querySelector(".accordion-content");
        content.style.height = content.scrollHeight + "px";

        accordionImages.forEach(img => img.classList.remove('active'));
        accordionImages[index].classList.add('active');
    }

    accordionItems.forEach((item, index) => {
        item.addEventListener('click', () => {
            if (!item.classList.contains("active")) setActiveItem(index);
            else {
                item.classList.remove('active')
                const accordionItem = item.querySelector('.accordion-item');
                accordionItem.classList.remove('active');
                const accordionClose = accordionItem.querySelector('.accordion-close');
                accordionClose.innerHTML = "Open";

                const content = accordionItem.querySelector(".accordion-content");
                content.style.height = 0;
            }
        });
    });
    
    setActiveItem(0);
});